import * as React from "react";
import useDebounce from "Hooks/useDebounce";
import { TextInput } from "Components/Shared/Inputs/TextInput";
import styled from "styled-components";

type Props = {
  placeholder: string;
  onSearch?: (searchQuery: string) => void;
  debounceTime?: number;
};

const StyledWrapper = styled.div`
  input {
    background-color: #fff;
  }
`;

export const SearchBar: React.FunctionComponent<Props> = props => {
  const { onSearch, placeholder, debounceTime } = props;
  const [searchTerm, setSearchTerm] = React.useState("");
  const [lastSearchTerm, setLastSearchTerm] = React.useState("");
  const debouncedSearchTerm = useDebounce(
    searchTerm,
    debounceTime || 500,
  ) as string;

  React.useEffect(() => {
    if (debouncedSearchTerm !== lastSearchTerm) {
      onSearch && onSearch(debouncedSearchTerm);
      setLastSearchTerm(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm, onSearch, lastSearchTerm, setLastSearchTerm]);

  return (
    <StyledWrapper>
      <TextInput
        placeholder={placeholder}
        margin={"none"}
        fullWidth
        onChange={(e: { target: { value: React.SetStateAction<string> } }) =>
          setSearchTerm(e.target.value)
        }
      />
    </StyledWrapper>
  );
};
